/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadCursor
 */
export interface ReadCursor {
    /**
     * 
     */
    last_read_message_id: string | null;
}

/**
 * Check if a given object implements the ReadCursor interface.
 */
export function instanceOfReadCursor(value: object): value is ReadCursor {
    if (!('last_read_message_id' in value) || value['last_read_message_id'] === undefined) return false;
    return true;
}

export function ReadCursorFromJSON(json: any): ReadCursor {
    return ReadCursorFromJSONTyped(json, false);
}

export function ReadCursorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadCursor {
    if (json == null) {
        return json;
    }
    return {
        
        'last_read_message_id': json['last_read_message_id'],
    };
}

export function ReadCursorToJSON(json: any): ReadCursor {
    return ReadCursorToJSONTyped(json, false);
}

export function ReadCursorToJSONTyped(value?: ReadCursor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_read_message_id': value['last_read_message_id'],
    };
}

